<template lang="pug">
  .bcard-btnbar(v-if="isLatest === '1'")
    span.label.label-info(data-testid="-label-is-latest") 最新の名刺
  .bcard-btnbar(v-else-if="isLatest === '0'")
    span.label.label-default(data-testid="-label-isnot-latest") 過去の名刺
</template>

<script>
export default {
  name: 'LatestLabel',
  props: {
    isLatest: { type: String, required: false, default: '' }
  }
}
</script>

<style lang="scss" scoped>
  .bcard-btnbar {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/molecules/LatestLabel.vue